import { createSelector } from 'reselect';
import { stateParamsReducerKey } from '@Constants/StateParamsConstants';

import { tgitems, reactions, citations, substances } from '@Constants';
import { fromJS } from 'immutable';
import { getCombinedRouteParams } from '@AppRoutes/AppRoutesSelectors';

export function stateParams(state) {
  return fromJS(getCombinedRouteParams(state));
}

export function context(state) {
  return stateParams(state).get('context');
}

export function isTgitemsContext(state) {
  return context(state) === tgitems;
}

export function isReactionsContext(state) {
  return context(state) === reactions;
}

export function isCitationsContext(state) {
  return context(state) === citations;
}

export function isSubstancesContext(state) {
  return context(state) === substances;
}

export function databaseId(state) {
  return stateParams(state).get('databaseId');
}

export function hitSetKey(state) {
  return stateParams(state).get('hitSetKey');
}

export function pageNumber(state) {
  return stateParams(state).get('pageNumber');
}

export function searchId(state) {
  return stateParams(state).get('searchId');
}

export function sort(state) {
  return stateParams(state).get('sort');
}

export function order(state) {
  return stateParams(state).get('order');
}

export function previousStateParams(state) {
  return state.getIn([stateParamsReducerKey, 'previousStateParams']);
}

export function stateParamsSelectorFactory(params, stateParamsSelector = stateParams) {
  const paramsSelectors = params.map((item) => (state) => stateParamsSelector(state).get(item));
  return createSelector(paramsSelectors, (...args) =>
    args.reduce((res, item, index) => {
      res[params[index]] = item;

      return res;
    }, {})
  );
}
